export default __webpack_public_path__ + "static/media/memsql.aecce246.svg";